import { messages } from './messages'

export const investmentConditionsTable = [
  {
    captionId: 'conditions',
    values: [
      {
        descriptions: [
          {
            titleId: 'investment',
          },
        ],
      },
      {
        descriptions: [
          {
            noticeId: 'onlyForBusiness',
            titleId: 'rules',
          },
        ],
      },
    ],
  },
  {
    captionId: 'creditSum',
    values: [
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.investment',
            textId: 'creditSum.first',
          },
        ],
      },
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.rules',
            textId: 'creditSum.second',
            noticeId: 'onlyForBusiness',
          },
        ],
      },
    ],
  },
  {
    captionId: 'deadline',
    values: [
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.investment',
            textId: 'deadline.investment.first',
          },
        ],
      },
      {
        descriptions: [
          {
            mobileInnerHeadingId: 'innerHeading.rules',
            textId: 'deadline.investment.second',
            noticeId: 'onlyForBusiness',
          },
        ],
      },
    ],
  },
  {
    captionId: 'goal',
    values: [
      {
        descriptions: [
          {
            textId: 'goal.investment.first',
          },
          {
            textId: 'goal.investment.second',
          },
        ],
      },
    ],
  },
  {
    captionId: 'form',
    values: [
      {
        descriptions: [
          {
            textId: 'form',
          },
        ],
      },
    ],
  },
  {
    captionId: 'provision',
    values: [
      {
        descriptions: [
          {
            textId: 'provision.first',
          },
          {
            textId: 'provision.second',
          },
          {
            textId: 'provision.third',
          },
        ],
      },
    ],
  },
]

export const details = [
  {
    value: messages.details.value.untilFifeHundredMillions,
    sign: messages.details.sign.creditSize,
  },
  {
    value: messages.details.value.fromOnePercent,
    sign: messages.details.sign.preferentialRate,
  },
  {
    value: messages.details.value.untilFifteenYears,
    sign: messages.details.sign.deadline,
  },
]

export const benefits = [
  {
    icon: 'price',
    description: messages.benefits.description.differentDepositVariants,
  },
  {
    icon: 'calender',
    description: messages.benefits.description.comfortableRepaymentSchedule,
  },
  {
    icon: 'timer',
    description: messages.benefits.description.optimalDeadline,
  },
]

export const steps = Array.from({ length: 5 }, (element, index) => messages.steps[String(index + 1) as keyof typeof messages.steps])
